module.exports = __webpack_public_path__ + "img/bg_yixiubao.16750705.svg";